<template>
  <UISort
    v-model="clearedSort"
    v-model:storage="sortStorage"
    :fields="sortFields"
    :readonly
    disallow-drag
    placement="bottom-end"
  >
    <template #default="{ count, handleToggle, handleClear }">
      <DSButtonIndicator
        v-bind="$attrs"
        variant="secondary"
        :size="isMobile ? 'icon-sm' : 'sm'"
        :indicator="(count ?? 0) > 0"
        clearable
        :readonly
        @click.stop="handleToggle"
        @click:clear="handleClear"
      >
        <ArrowUpDown />
        <template v-if="!isMobile">
          {{ label }}
        </template>
      </DSButtonIndicator>
    </template>
  </UISort>
</template>

<script setup lang="ts">
import { Sort } from '@types'

import { DSButtonIndicator } from '@ds'
import type { PivotTableSortOption } from '@/components/DS/patterns/Pivot/utils/types'
import { ArrowUpDown } from '@lucide/vue'
import { UISort } from '@ui/controllers'

interface PivotSortControlProps {
  label: string
  sortFields: PivotTableSortOption[]
  readonly?: boolean
  isMobile?: boolean
}

defineProps<PivotSortControlProps>()

defineOptions({
  inheritAttrs: false,
})

const clearedSort = defineModel<Sort[]>('cleared-sort')
const sortStorage = defineModel<Sort[]>('sort-storage')
</script>
